import { ActionTypes } from "./types";

const {
  SET_MONTHLY_CLOSINGS,
  SET_FILTERS,
  CLEAR_MONTHLY_CLOSINGS,
  RESTORE_INITIAL,
} = ActionTypes;

const now = new Date();
const currentMonth = now.getMonth() + 1;
const currentYear = now.getFullYear();

const INITIAL_STATE = {
  closings: [],
  station: null,
  month: currentMonth,
  year: currentYear,
};

export const monthlyClosingReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_MONTHLY_CLOSINGS:
      return {
        ...state,
        closings: payload.map((item) => ({
          ...item,
          monthlyTotal: item.monthlyBalance,
        })),
      };

    case SET_FILTERS: {
      let closings = state.closings;
      if (payload.key === "station") closings = [];
      return { ...state, [payload.key]: payload.value, closings };
    }

    case CLEAR_MONTHLY_CLOSINGS:
      return { ...state, closings: [] };

    case RESTORE_INITIAL:
      return INITIAL_STATE;

    case "CLOSE_SESSION_LOGIN":
      return INITIAL_STATE;

    default:
      return state;
  }
};
